import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../Navbar/navbar';
import Texteditor from '../Texteditor/Texteditor.jsx';
import { getWorksheet } from '../../data/worksheetsApi';
import '../Layout/Layout.css';

const WorksheetView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [worksheet, setWorksheet] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setWorksheet(null);
    setNotFound(false);

    (async () => {
      const { data, error } = await getWorksheet(id);
      if (cancelled) return;

      if (error || !data) {
        setNotFound(true);
        return;
      }
      setWorksheet(data);
    })();

    return () => {
      cancelled = true;
    };
  }, [id]);

  useEffect(() => {
    if (notFound) navigate('/worksheets', { replace: true });
  }, [notFound, navigate]);

  return (
    <div className="worksheet-page">
      <Navbar />
      <div className="layout-body">
        {!worksheet ? (
          <p style={{ padding: 24 }}>Loading worksheet…</p>
        ) : (
          <div className="layout">
            <div className="right-half">
              <Texteditor
                questions={[]}
                template_id={worksheet.template_id}
                initialContent={worksheet.content}
                worksheetId={worksheet.id}
                worksheetTitle={worksheet.title}
                sourcePrompt={worksheet.source_prompt}
                onVersionCreated={newId => { if(newId===id)window.location.reload();else navigate(`/worksheet/${newId}`); }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorksheetView;
